{
  "name": "@srgssr/brand-button",
  "version": "1.2.0",
  "license": "MIT",
  "author": "SRG SSR",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/SRGSSR/pillarbox-web-suite.git"
  },
  "publishConfig": {
    "access": "public"
  },
  "homepage": "https://github.com/SRGSSR/pillarbox-web-suite/tree/main/packages/brand-button#readme",
  "type": "module",
  "main": "dist/brand-button.cjs",
  "browser": "dist/brand-button.umd.min.js",
  "module": "dist/brand-button.js",
  "style": "./dist/brand-button.min.css",
  "exports": {
    ".": {
      "import": "./dist/brand-button.js",
      "require": "./dist/brand-button.cjs"
    },
    "./*": "./*"
  },
  "files": [
    "dist/*",
    "scss/*"
  ],
  "keywords": [
    "video.js",
    "player"
  ],
  "scripts": {
    "clean": "rimraf dist",
    "build": "npm-run-all clean build:*",
    "build:css": "sass ./scss/brand-button.scss:dist/brand-button.min.css --style compressed --source-map --load-path node_modules",
    "build:lib": "vite build --config vite.config.lib.js",
    "build:umd": "vite build --config vite.config.umd.js",
    "github:page": "vite build",
    "release:ci": "semantic-release",
    "start": " vite --port 4200 --open",
    "test": "vitest run --silent --coverage --coverage.reporter text"
  },
  "dependencies": {
    "@srgssr/svg-button": "^1.0.0"
  },
  "peerDependencies": {
    "video.js": "^8.0.0"
  },
  "devDependencies": {
    "@srgssr/pillarbox-web": "^1.24.1"
  }
}
